import { withInstall } from '@zoryn/utils'
import InputNumber from './src/input-number.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZInputNumber: SFCWithInstall<typeof InputNumber> =
  withInstall(InputNumber)

export default ZInputNumber
export * from './src/input-number'
